import { Divider } from '@mui/material';
import TextField from '@mui/material/TextField';
import { MemreButton, MemreFlexBox, MemreModal } from 'components/core';
import { useState } from 'react';
import { QuestionAndAnswer } from 'services/useItem.service/interactions';
import { useAuthoringContext } from '../AuthoringContext';
import Answer from '../components/Answer';
import AttachInstructionalItem from '../components/AttachInstructionalItem';
import GraduatedDifficulty from '../components/GraduatedDifficulty';
import ImageUploadModal from '../components/ImageUpload/ImageUploadModal';
import Sound from '../components/Sound';
import SuggestedDistractors from '../components/SuggestedDistractors';

export default function MultipleChoiceQuestion() {
  const questionAndAnswer = useAuthoringContext()?.item as QuestionAndAnswer;

  const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

  const handleAddImage = (addImageMethod) => {
    setModalContent(<ImageUploadModal addImageMethod={addImageMethod} close={() => setModalContent(null)} />);
  };

  return (
    <MemreFlexBox
      direction="column"
      gap={2}
      sx={{
        p: 2,
        pl: 0,
        width: '100%',
      }}
    >
      <MemreFlexBox direction="row" gap={2}>
        <TextField
          label="Question Text"
          variant="outlined"
          sx={{ flex: 1 }}
          value={questionAndAnswer.question.text}
          onChange={(e) => questionAndAnswer.updateQuestion(e.target.value)}
        />
        {questionAndAnswer.question.image?.url && (
          <MemreFlexBox
            direction="column"
            sx={{ position: 'relative', height: '100%' }}
            align="center"
            justify="center"
          >
            <div
              style={{
                aspectRatio: '1/1',
                height: '100%',
                backgroundImage: `url(${questionAndAnswer.question.image.url})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                borderRadius: '4px',
              }}
            />
            <MemreButton
              variant="icon"
              iconName="trash"
              onClick={questionAndAnswer.question.image.delete}
              sx={{ position: 'absolute', backgroundColor: 'white' }}
            />
          </MemreFlexBox>
        )}
        {!questionAndAnswer.question.image?.url && (
          <MemreButton
            text="Add Image"
            iconName="image"
            variant="outlined"
            size="small"
            onClick={() => handleAddImage(questionAndAnswer.question.image.add)}
          />
        )}
        <Sound
          url={questionAndAnswer.question.sound?.url}
          add={questionAndAnswer.question.sound?.add}
          handleDelete={questionAndAnswer.question.sound?.delete}
        />
      </MemreFlexBox>
      {questionAndAnswer?.answers.map((answer, i) => (
        <Answer key={`${answer.id}${i}`} answer={answer} handleAddImage={handleAddImage} />
      ))}
      <MemreButton
        variant="text"
        text="Add Answer"
        size="small"
        iconName="plus"
        onClick={() => questionAndAnswer.add()}
      />

      {questionAndAnswer?.id && (
        <SuggestedDistractors
          questionText={questionAndAnswer.question.text || ''}
          correctAnswers={questionAndAnswer.answers
            .filter((answer) => answer.isCorrect)
            .map((answer) => answer.text || '')}
          existingAnswers={questionAndAnswer.answers.map((answer) => answer.text || '')}
          onAddDistractor={async (distractor) => {
            await questionAndAnswer.add(distractor);
          }}
        />
      )}
      <Divider sx={{ width: '100%', m: 0.5, mt: 2 }} />

      {questionAndAnswer?.id && <AttachInstructionalItem itemId={questionAndAnswer.id} />}

      <Divider sx={{ width: '100%', m: 0.5, mt: 2 }} />

      {questionAndAnswer?.id && <GraduatedDifficulty itemId={questionAndAnswer.id} />}

      <MemreModal padding={0}>{modalContent}</MemreModal>
    </MemreFlexBox>
  );
}
